<script lang="ts" setup>
import { UiButtonIcon } from '../ui-button-icon';
interface Props {
  disabled?: boolean;
}
defineOptions({ inheritAttrs: false });
const props = defineProps<Props>();
</script>

<template>
  <div :class="$style.root">
    <UiButtonIcon v-bind="$attrs" variant="tertiary" :disabled="props.disabled">
      <slot />
    </UiButtonIcon>
  </div>
</template>

<style lang="scss" module>
@use '../../styles/spacing';

.root {
  padding: spacing.$spacer-2;

  & + & {
    border-left: 1px solid var(--ui2-stroke-secondary);
  }
}
</style>
